<int-integrators-details
        [integrationName]="integrationName"
        [integrationType]="integrationType"
        [creating]="creating"
        [user]="user"
        [invites]="invites"></int-integrators-details>

<div class="content" mat-dialog-content>
  <div *ngIf="creating" class="int-text-container">
    {{description}}
  </div>

  <mat-spinner *ngIf="loading" diameter="40"></mat-spinner>
  <div *ngIf="accounts && accounts.length > 0 && !loading">
    <mat-form-field>
      <mat-select placeholder="Select an Ad Account" [disabled]="accountsDisabled" [(ngModel)]="adAccount">
        <mat-option *ngFor="let account of accounts" [value]="account.id">
          {{ account.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="isAdmin && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      <mat-icon>add</mat-icon>
      <span class="center-text">ADD ANOTHER ACCOUNT</span>
    </button>
  </div>

  <div *ngIf="!noAccounts && !creating">
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
      <mat-icon>expand_more</mat-icon>
      <span>SHOW CONNECTED ACCOUNTS</span>
    </button>
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
      <mat-icon>expand_less</mat-icon>
      <span>HIDE CONNECTED ACCOUNTS</span>
    </button>
  </div>

  <div *ngIf="!creating" [hidden]="!showAccounts">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <div *ngFor="let int of existingIntegrations">Account Name: {{ int.friendlyName }}</div>
  </div>
</div>

<div class="buttons" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="center">
    <button
            id="snapchat-login-button"
            class="pa-1 pr-2"
            *ngIf="creating && !loading && !accounts.length"
            (click)="login($event)"
            mat-raised-button
    >
      <img src="../../../../assets/image/snap-ghost-yellow.png" id="snap-button-logo" /> Continue with Snapchat
    </button>
  </div>
  <div fxLayout="row" fxLayoutAlign="center">
    <p *ngIf="!creating && !loading && loginError" class="mat-text-warn">
      There was a problem connecting to Snapchat. Please try again later.
    </p>
    <p *ngIf="creating && !loading && createdIntegration.id && !(accounts && accounts.length)" class="mat-text-warn">
      We couldn't find an ads account for that login.
    </p>
  </div>
</div>

<div mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>CANCEL</button>
    <button
      *ngIf="creating && accounts"
      [disabled]="accountsDisabled || !adAccount"
      mat-raised-button
      (click)="addAccount($event)"
      color="primary"
    >
      SAVE
    </button>
  </div>
</div>
